import { Pipe, PipeTransform } from '@angular/core';
import { jobStatus } from "../../shared/constants/scheduled-job-constant";
@Pipe({
  name: 'scheduledJobStatus'
})
export class ScheduledJobStatusPipe implements PipeTransform {

  transform(value): string {
      switch (value) {
          case jobStatus.WAITING:
              return 'Waiting to trigger';
          case jobStatus.TRIGGERED:
              return 'Triggered'
          default:
              return value;
      }
  }
}
